import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getPendingFrontlinerOptions } from './get-pending-frontliner-options'
import { getTodoFrontlinerOptions } from './get-todo-frontliner-options'

export const getFrontlineActionButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { task } = props
  const { statusFe } = task

  switch (statusFe) {
    case TASK_STATES.todo:
      return getTodoFrontlinerOptions(props)

    case TASK_STATES.pending:
      return getPendingFrontlinerOptions(props)

    default:
      return []
  }
}
